import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations - zh-TW
import zhTWCommon from './locales/zh-TW/common.json';
import zhTWNav from './locales/zh-TW/nav.json';
import zhTWAuth from './locales/zh-TW/auth.json';
import zhTWPricing from './locales/zh-TW/pricing.json';
import zhTWHome from './locales/zh-TW/home.json';
import zhTWCourse from './locales/zh-TW/course.json';
import zhTWLearning from './locales/zh-TW/learning.json';
import zhTWLegal from './locales/zh-TW/legal.json';
import zhTWCreator from './locales/zh-TW/creator.json';
import zhTWTokens from './locales/zh-TW/tokens.json';
import zhTWReferral from './locales/zh-TW/referral.json';
import zhTWPlacementTest from './locales/zh-TW/placementTest.json';
import zhTWWriting from './locales/zh-TW/writing.json';
import zhTWProgression from './locales/zh-TW/progression.json';
import zhTWMessaging from './locales/zh-TW/messaging.json';
import zhTWNotification from './locales/zh-TW/notification.json';
import zhTWProfile from './locales/zh-TW/profile.json';
import zhTWWelcome from './locales/zh-TW/welcome.json';
import zhTWAbout from './locales/zh-TW/about.json';
import zhTWBlog from './locales/zh-TW/blog.json';
import zhTWVocabulary from './locales/zh-TW/vocabulary.json';
import zhTWPlaylist from './locales/zh-TW/playlist.json';
import zhTWSeries from './locales/zh-TW/series.json';
import zhTWSubtitle from './locales/zh-TW/subtitle.json';
import zhTWDictionary from './locales/zh-TW/dictionary.json';
import zhTWCefrGuide from './locales/zh-TW/cefrGuide.json';
import zhTWAdmin from './locales/zh-TW/admin.json';
import zhTWKnowledgeGraph from './locales/zh-TW/knowledgeGraph.json';
import zhTWPhonicsRef from './locales/zh-TW/phonicsRef.json';
import zhTWMorphRef from './locales/zh-TW/morphRef.json';
import zhTWProsodyRef from './locales/zh-TW/prosodyRef.json';
import zhTWSightWordsRef from './locales/zh-TW/sightWordsRef.json';
import zhTWEmailHub from './locales/zh-TW/emailHub.json';
import zhTWLearningJourney from './locales/zh-TW/learningJourney.json';
import zhTWGuidanceRef from './locales/zh-TW/guidanceRef.json';
import zhTWWishlist from './locales/zh-TW/wishlist.json';
import zhTWConversationalEditor from './locales/zh-TW/conversationalEditor.json';
import zhTWLearningReport from './locales/zh-TW/learningReport.json';
import zhTWFaq from './locales/zh-TW/faq.json';
import zhTWReview from './locales/zh-TW/review.json';

// Import translations - zh-CN

import zhCNCommon from './locales/zh-CN/common.json';
import zhCNNav from './locales/zh-CN/nav.json';
import zhCNAuth from './locales/zh-CN/auth.json';
import zhCNPricing from './locales/zh-CN/pricing.json';
import zhCNHome from './locales/zh-CN/home.json';
import zhCNCourse from './locales/zh-CN/course.json';
import zhCNLearning from './locales/zh-CN/learning.json';
import zhCNLegal from './locales/zh-CN/legal.json';
import zhCNCreator from './locales/zh-CN/creator.json';
import zhCNTokens from './locales/zh-CN/tokens.json';
import zhCNReferral from './locales/zh-CN/referral.json';
import zhCNPlacementTest from './locales/zh-CN/placementTest.json';
import zhCNWriting from './locales/zh-CN/writing.json';
import zhCNProgression from './locales/zh-CN/progression.json';
import zhCNMessaging from './locales/zh-CN/messaging.json';
import zhCNNotification from './locales/zh-CN/notification.json';
import zhCNProfile from './locales/zh-CN/profile.json';
import zhCNWelcome from './locales/zh-CN/welcome.json';
import zhCNAbout from './locales/zh-CN/about.json';
import zhCNBlog from './locales/zh-CN/blog.json';
import zhCNVocabulary from './locales/zh-CN/vocabulary.json';
import zhCNPlaylist from './locales/zh-CN/playlist.json';
import zhCNSeries from './locales/zh-CN/series.json';
import zhCNSubtitle from './locales/zh-CN/subtitle.json';
import zhCNDictionary from './locales/zh-CN/dictionary.json';
import zhCNCefrGuide from './locales/zh-CN/cefrGuide.json';
import zhCNAdmin from './locales/zh-CN/admin.json';
import zhCNKnowledgeGraph from './locales/zh-CN/knowledgeGraph.json';
import zhCNPhonicsRef from './locales/zh-CN/phonicsRef.json';
import zhCNMorphRef from './locales/zh-CN/morphRef.json';
import zhCNProsodyRef from './locales/zh-CN/prosodyRef.json';
import zhCNSightWordsRef from './locales/zh-CN/sightWordsRef.json';
import zhCNEmailHub from './locales/zh-CN/emailHub.json';
import zhCNLearningJourney from './locales/zh-CN/learningJourney.json';
import zhCNGuidanceRef from './locales/zh-CN/guidanceRef.json';
import zhCNWishlist from './locales/zh-CN/wishlist.json';
import zhCNConversationalEditor from './locales/zh-CN/conversationalEditor.json';
import zhCNLearningReport from './locales/zh-CN/learningReport.json';
import zhCNFaq from './locales/zh-CN/faq.json';
import zhCNReview from './locales/zh-CN/review.json';

// Import translations - ko
import koCommon from './locales/ko/common.json';
import koNav from './locales/ko/nav.json';
import koAuth from './locales/ko/auth.json';
import koPricing from './locales/ko/pricing.json';
import koHome from './locales/ko/home.json';
import koCourse from './locales/ko/course.json';
import koLearning from './locales/ko/learning.json';
import koLegal from './locales/ko/legal.json';
import koCreator from './locales/ko/creator.json';
import koTokens from './locales/ko/tokens.json';
import koReferral from './locales/ko/referral.json';
import koPlacementTest from './locales/ko/placementTest.json';
import koWriting from './locales/ko/writing.json';
import koProgression from './locales/ko/progression.json';
import koMessaging from './locales/ko/messaging.json';
import koNotification from './locales/ko/notification.json';
import koProfile from './locales/ko/profile.json';
import koWelcome from './locales/ko/welcome.json';
import koAbout from './locales/ko/about.json';
import koBlog from './locales/ko/blog.json';
import koVocabulary from './locales/ko/vocabulary.json';
import koPlaylist from './locales/ko/playlist.json';
import koSeries from './locales/ko/series.json';
import koSubtitle from './locales/ko/subtitle.json';
import koDictionary from './locales/ko/dictionary.json';
import koCefrGuide from './locales/ko/cefrGuide.json';
import koAdmin from './locales/ko/admin.json';
import koKnowledgeGraph from './locales/ko/knowledgeGraph.json';
import koPhonicsRef from './locales/ko/phonicsRef.json';
import koMorphRef from './locales/ko/morphRef.json';
import koProsodyRef from './locales/ko/prosodyRef.json';
import koSightWordsRef from './locales/ko/sightWordsRef.json';
import koEmailHub from './locales/ko/emailHub.json';
import koLearningJourney from './locales/ko/learningJourney.json';
import koGuidanceRef from './locales/ko/guidanceRef.json';
import koWishlist from './locales/ko/wishlist.json';
import koConversationalEditor from './locales/ko/conversationalEditor.json';
import koLearningReport from './locales/ko/learningReport.json';
import koFaq from './locales/ko/faq.json';
import koReview from './locales/ko/review.json';

// Import translations - en
import enCommon from './locales/en/common.json';
import enNav from './locales/en/nav.json';
import enAuth from './locales/en/auth.json';
import enPricing from './locales/en/pricing.json';
import enHome from './locales/en/home.json';
import enCourse from './locales/en/course.json';
import enLearning from './locales/en/learning.json';
import enLegal from './locales/en/legal.json';
import enCreator from './locales/en/creator.json';
import enTokens from './locales/en/tokens.json';
import enReferral from './locales/en/referral.json';
import enPlacementTest from './locales/en/placementTest.json';
import enWriting from './locales/en/writing.json';
import enProgression from './locales/en/progression.json';
import enMessaging from './locales/en/messaging.json';
import enNotification from './locales/en/notification.json';
import enProfile from './locales/en/profile.json';
import enWelcome from './locales/en/welcome.json';
import enAbout from './locales/en/about.json';
import enBlog from './locales/en/blog.json';
import enVocabulary from './locales/en/vocabulary.json';
import enPlaylist from './locales/en/playlist.json';
import enSeries from './locales/en/series.json';
import enSubtitle from './locales/en/subtitle.json';
import enDictionary from './locales/en/dictionary.json';
import enCefrGuide from './locales/en/cefrGuide.json';
import enAdmin from './locales/en/admin.json';
import enKnowledgeGraph from './locales/en/knowledgeGraph.json';
import enPhonicsRef from './locales/en/phonicsRef.json';
import enMorphRef from './locales/en/morphRef.json';
import enProsodyRef from './locales/en/prosodyRef.json';
import enSightWordsRef from './locales/en/sightWordsRef.json';
import enEmailHub from './locales/en/emailHub.json';
import enLearningJourney from './locales/en/learningJourney.json';
import enGuidanceRef from './locales/en/guidanceRef.json';
import enWishlist from './locales/en/wishlist.json';
import enConversationalEditor from './locales/en/conversationalEditor.json';
import enLearningReport from './locales/en/learningReport.json';
import enFaq from './locales/en/faq.json';
import enReview from './locales/en/review.json';

// Import translations - ja
import jaCommon from './locales/ja/common.json';
import jaNav from './locales/ja/nav.json';
import jaAuth from './locales/ja/auth.json';
import jaPricing from './locales/ja/pricing.json';
import jaHome from './locales/ja/home.json';
import jaCourse from './locales/ja/course.json';
import jaLearning from './locales/ja/learning.json';
import jaLegal from './locales/ja/legal.json';
import jaCreator from './locales/ja/creator.json';
import jaTokens from './locales/ja/tokens.json';
import jaReferral from './locales/ja/referral.json';
import jaPlacementTest from './locales/ja/placementTest.json';
import jaWriting from './locales/ja/writing.json';
import jaProgression from './locales/ja/progression.json';
import jaMessaging from './locales/ja/messaging.json';
import jaNotification from './locales/ja/notification.json';
import jaProfile from './locales/ja/profile.json';
import jaWelcome from './locales/ja/welcome.json';
import jaAbout from './locales/ja/about.json';
import jaBlog from './locales/ja/blog.json';
import jaVocabulary from './locales/ja/vocabulary.json';
import jaPlaylist from './locales/ja/playlist.json';
import jaSeries from './locales/ja/series.json';
import jaSubtitle from './locales/ja/subtitle.json';
import jaDictionary from './locales/ja/dictionary.json';
import jaCefrGuide from './locales/ja/cefrGuide.json';
import jaAdmin from './locales/ja/admin.json';
import jaKnowledgeGraph from './locales/ja/knowledgeGraph.json';
import jaPhonicsRef from './locales/ja/phonicsRef.json';
import jaMorphRef from './locales/ja/morphRef.json';
import jaProsodyRef from './locales/ja/prosodyRef.json';
import jaSightWordsRef from './locales/ja/sightWordsRef.json';
import jaEmailHub from './locales/ja/emailHub.json';
import jaLearningJourney from './locales/ja/learningJourney.json';
import jaGuidanceRef from './locales/ja/guidanceRef.json';
import jaWishlist from './locales/ja/wishlist.json';
import jaConversationalEditor from './locales/ja/conversationalEditor.json';
import jaLearningReport from './locales/ja/learningReport.json';
import jaFaq from './locales/ja/faq.json';
import jaReview from './locales/ja/review.json';

// Import translations - ms
import msCommon from './locales/ms/common.json';
import msNav from './locales/ms/nav.json';
import msAuth from './locales/ms/auth.json';
import msPricing from './locales/ms/pricing.json';
import msHome from './locales/ms/home.json';
import msCourse from './locales/ms/course.json';
import msLearning from './locales/ms/learning.json';
import msLegal from './locales/ms/legal.json';
import msCreator from './locales/ms/creator.json';
import msTokens from './locales/ms/tokens.json';
import msReferral from './locales/ms/referral.json';
import msPlacementTest from './locales/ms/placementTest.json';
import msWriting from './locales/ms/writing.json';
import msProgression from './locales/ms/progression.json';
import msMessaging from './locales/ms/messaging.json';
import msNotification from './locales/ms/notification.json';
import msProfile from './locales/ms/profile.json';
import msWelcome from './locales/ms/welcome.json';
import msAbout from './locales/ms/about.json';
import msBlog from './locales/ms/blog.json';
import msVocabulary from './locales/ms/vocabulary.json';
import msPlaylist from './locales/ms/playlist.json';
import msSeries from './locales/ms/series.json';
import msSubtitle from './locales/ms/subtitle.json';
import msDictionary from './locales/ms/dictionary.json';
import msCefrGuide from './locales/ms/cefrGuide.json';
import msAdmin from './locales/ms/admin.json';
import msKnowledgeGraph from './locales/ms/knowledgeGraph.json';
import msPhonicsRef from './locales/ms/phonicsRef.json';
import msMorphRef from './locales/ms/morphRef.json';
import msProsodyRef from './locales/ms/prosodyRef.json';
import msSightWordsRef from './locales/ms/sightWordsRef.json';
import msEmailHub from './locales/ms/emailHub.json';
import msLearningJourney from './locales/ms/learningJourney.json';
import msGuidanceRef from './locales/ms/guidanceRef.json';
import msWishlist from './locales/ms/wishlist.json';
import msConversationalEditor from './locales/ms/conversationalEditor.json';
import msLearningReport from './locales/ms/learningReport.json';
import msFaq from './locales/ms/faq.json';
import msReview from './locales/ms/review.json';

// Import translations - id
import idCommon from './locales/id/common.json';
import idNav from './locales/id/nav.json';
import idAuth from './locales/id/auth.json';
import idPricing from './locales/id/pricing.json';
import idHome from './locales/id/home.json';
import idCourse from './locales/id/course.json';
import idLearning from './locales/id/learning.json';
import idLegal from './locales/id/legal.json';
import idCreator from './locales/id/creator.json';
import idTokens from './locales/id/tokens.json';
import idReferral from './locales/id/referral.json';
import idPlacementTest from './locales/id/placementTest.json';
import idWriting from './locales/id/writing.json';
import idProgression from './locales/id/progression.json';
import idMessaging from './locales/id/messaging.json';
import idNotification from './locales/id/notification.json';
import idProfile from './locales/id/profile.json';
import idWelcome from './locales/id/welcome.json';
import idAbout from './locales/id/about.json';
import idBlog from './locales/id/blog.json';
import idVocabulary from './locales/id/vocabulary.json';
import idPlaylist from './locales/id/playlist.json';
import idSeries from './locales/id/series.json';
import idSubtitle from './locales/id/subtitle.json';
import idDictionary from './locales/id/dictionary.json';
import idCefrGuide from './locales/id/cefrGuide.json';
import idAdmin from './locales/id/admin.json';
import idKnowledgeGraph from './locales/id/knowledgeGraph.json';
import idPhonicsRef from './locales/id/phonicsRef.json';
import idMorphRef from './locales/id/morphRef.json';
import idProsodyRef from './locales/id/prosodyRef.json';
import idSightWordsRef from './locales/id/sightWordsRef.json';
import idEmailHub from './locales/id/emailHub.json';
import idLearningJourney from './locales/id/learningJourney.json';
import idGuidanceRef from './locales/id/guidanceRef.json';
import idWishlist from './locales/id/wishlist.json';
import idConversationalEditor from './locales/id/conversationalEditor.json';
import idLearningReport from './locales/id/learningReport.json';
import idFaq from './locales/id/faq.json';
import idReview from './locales/id/review.json';

// Import translations - th
import thCommon from './locales/th/common.json';
import thNav from './locales/th/nav.json';
import thAuth from './locales/th/auth.json';
import thPricing from './locales/th/pricing.json';
import thHome from './locales/th/home.json';
import thCourse from './locales/th/course.json';
import thLearning from './locales/th/learning.json';
import thLegal from './locales/th/legal.json';
import thCreator from './locales/th/creator.json';
import thTokens from './locales/th/tokens.json';
import thReferral from './locales/th/referral.json';
import thPlacementTest from './locales/th/placementTest.json';
import thWriting from './locales/th/writing.json';
import thProgression from './locales/th/progression.json';
import thMessaging from './locales/th/messaging.json';
import thNotification from './locales/th/notification.json';
import thProfile from './locales/th/profile.json';
import thWelcome from './locales/th/welcome.json';
import thAbout from './locales/th/about.json';
import thBlog from './locales/th/blog.json';
import thVocabulary from './locales/th/vocabulary.json';
import thPlaylist from './locales/th/playlist.json';
import thSeries from './locales/th/series.json';
import thSubtitle from './locales/th/subtitle.json';
import thDictionary from './locales/th/dictionary.json';
import thCefrGuide from './locales/th/cefrGuide.json';
import thAdmin from './locales/th/admin.json';
import thKnowledgeGraph from './locales/th/knowledgeGraph.json';
import thPhonicsRef from './locales/th/phonicsRef.json';
import thMorphRef from './locales/th/morphRef.json';
import thProsodyRef from './locales/th/prosodyRef.json';
import thSightWordsRef from './locales/th/sightWordsRef.json';
import thEmailHub from './locales/th/emailHub.json';
import thLearningJourney from './locales/th/learningJourney.json';
import thGuidanceRef from './locales/th/guidanceRef.json';
import thWishlist from './locales/th/wishlist.json';
import thConversationalEditor from './locales/th/conversationalEditor.json';
import thLearningReport from './locales/th/learningReport.json';
import thFaq from './locales/th/faq.json';
import thReview from './locales/th/review.json';

// Import translations - vi
import viCommon from './locales/vi/common.json';
import viNav from './locales/vi/nav.json';
import viAuth from './locales/vi/auth.json';
import viPricing from './locales/vi/pricing.json';
import viHome from './locales/vi/home.json';
import viCourse from './locales/vi/course.json';
import viLearning from './locales/vi/learning.json';
import viLegal from './locales/vi/legal.json';
import viCreator from './locales/vi/creator.json';
import viTokens from './locales/vi/tokens.json';
import viReferral from './locales/vi/referral.json';
import viPlacementTest from './locales/vi/placementTest.json';
import viWriting from './locales/vi/writing.json';
import viProgression from './locales/vi/progression.json';
import viMessaging from './locales/vi/messaging.json';
import viNotification from './locales/vi/notification.json';
import viProfile from './locales/vi/profile.json';
import viWelcome from './locales/vi/welcome.json';
import viAbout from './locales/vi/about.json';
import viBlog from './locales/vi/blog.json';
import viVocabulary from './locales/vi/vocabulary.json';
import viPlaylist from './locales/vi/playlist.json';
import viSeries from './locales/vi/series.json';
import viSubtitle from './locales/vi/subtitle.json';
import viDictionary from './locales/vi/dictionary.json';
import viCefrGuide from './locales/vi/cefrGuide.json';
import viAdmin from './locales/vi/admin.json';
import viKnowledgeGraph from './locales/vi/knowledgeGraph.json';
import viPhonicsRef from './locales/vi/phonicsRef.json';
import viMorphRef from './locales/vi/morphRef.json';
import viProsodyRef from './locales/vi/prosodyRef.json';
import viSightWordsRef from './locales/vi/sightWordsRef.json';
import viEmailHub from './locales/vi/emailHub.json';
import viLearningJourney from './locales/vi/learningJourney.json';
import viGuidanceRef from './locales/vi/guidanceRef.json';
import viWishlist from './locales/vi/wishlist.json';
import viConversationalEditor from './locales/vi/conversationalEditor.json';
import viLearningReport from './locales/vi/learningReport.json';
import viFaq from './locales/vi/faq.json';
import viReview from './locales/vi/review.json';

const resources = {
  'zh-TW': {
    common: zhTWCommon,
    nav: zhTWNav,
    auth: zhTWAuth,
    pricing: zhTWPricing,
    home: zhTWHome,
    course: zhTWCourse,
    learning: zhTWLearning,
    legal: zhTWLegal,
    creator: zhTWCreator,
    tokens: zhTWTokens,
    referral: zhTWReferral,
    placementTest: zhTWPlacementTest,
    writing: zhTWWriting,
    progression: zhTWProgression,
    messaging: zhTWMessaging,
    notification: zhTWNotification,
    profile: zhTWProfile,
    welcome: zhTWWelcome,
    about: zhTWAbout,
    blog: zhTWBlog,
    vocabulary: zhTWVocabulary,
    playlist: zhTWPlaylist,
    series: zhTWSeries,
    subtitle: zhTWSubtitle,
    dictionary: zhTWDictionary,
    cefrGuide: zhTWCefrGuide,
    admin: zhTWAdmin,
    knowledgeGraph: zhTWKnowledgeGraph,
    phonicsRef: zhTWPhonicsRef,
    morphRef: zhTWMorphRef,
    prosodyRef: zhTWProsodyRef,
    sightWordsRef: zhTWSightWordsRef,
    emailHub: zhTWEmailHub,
    learningJourney: zhTWLearningJourney,
    guidanceRef: zhTWGuidanceRef,
    wishlist: zhTWWishlist,
    conversationalEditor: zhTWConversationalEditor,
    learningReport: zhTWLearningReport,
    faq: zhTWFaq,
    review: zhTWReview,
  },
  'zh-CN': {
    common: zhCNCommon,
    nav: zhCNNav,
    auth: zhCNAuth,
    pricing: zhCNPricing,
    home: zhCNHome,
    course: zhCNCourse,
    learning: zhCNLearning,
    legal: zhCNLegal,
    creator: zhCNCreator,
    tokens: zhCNTokens,
    referral: zhCNReferral,
    placementTest: zhCNPlacementTest,
    writing: zhCNWriting,
    progression: zhCNProgression,
    messaging: zhCNMessaging,
    notification: zhCNNotification,
    profile: zhCNProfile,
    welcome: zhCNWelcome,
    about: zhCNAbout,
    blog: zhCNBlog,
    vocabulary: zhCNVocabulary,
    playlist: zhCNPlaylist,
    series: zhCNSeries,
    subtitle: zhCNSubtitle,
    dictionary: zhCNDictionary,
    cefrGuide: zhCNCefrGuide,
    admin: zhCNAdmin,
    knowledgeGraph: zhCNKnowledgeGraph,
    phonicsRef: zhCNPhonicsRef,
    morphRef: zhCNMorphRef,
    prosodyRef: zhCNProsodyRef,
    sightWordsRef: zhCNSightWordsRef,
    emailHub: zhCNEmailHub,
    learningJourney: zhCNLearningJourney,
    guidanceRef: zhCNGuidanceRef,
    wishlist: zhCNWishlist,
    conversationalEditor: zhCNConversationalEditor,
    learningReport: zhCNLearningReport,
    faq: zhCNFaq,
    review: zhCNReview,
  },
  ko: {
    common: koCommon,
    nav: koNav,
    auth: koAuth,
    pricing: koPricing,
    home: koHome,
    course: koCourse,
    learning: koLearning,
    legal: koLegal,
    creator: koCreator,
    tokens: koTokens,
    referral: koReferral,
    placementTest: koPlacementTest,
    writing: koWriting,
    progression: koProgression,
    messaging: koMessaging,
    notification: koNotification,
    profile: koProfile,
    welcome: koWelcome,
    about: koAbout,
    blog: koBlog,
    vocabulary: koVocabulary,
    playlist: koPlaylist,
    series: koSeries,
    subtitle: koSubtitle,
    dictionary: koDictionary,
    cefrGuide: koCefrGuide,
    admin: koAdmin,
    knowledgeGraph: koKnowledgeGraph,
    phonicsRef: koPhonicsRef,
    morphRef: koMorphRef,
    prosodyRef: koProsodyRef,
    sightWordsRef: koSightWordsRef,
    emailHub: koEmailHub,
    learningJourney: koLearningJourney,
    guidanceRef: koGuidanceRef,
    wishlist: koWishlist,
    conversationalEditor: koConversationalEditor,
    learningReport: koLearningReport,
    faq: koFaq,
    review: koReview,
  },
  en: {
    common: enCommon,
    nav: enNav,
    auth: enAuth,
    pricing: enPricing,
    home: enHome,
    course: enCourse,
    learning: enLearning,
    legal: enLegal,
    creator: enCreator,
    tokens: enTokens,
    referral: enReferral,
    placementTest: enPlacementTest,
    writing: enWriting,
    progression: enProgression,
    messaging: enMessaging,
    notification: enNotification,
    profile: enProfile,
    welcome: enWelcome,
    about: enAbout,
    blog: enBlog,
    vocabulary: enVocabulary,
    playlist: enPlaylist,
    series: enSeries,
    subtitle: enSubtitle,
    dictionary: enDictionary,
    cefrGuide: enCefrGuide,
    admin: enAdmin,
    knowledgeGraph: enKnowledgeGraph,
    phonicsRef: enPhonicsRef,
    morphRef: enMorphRef,
    prosodyRef: enProsodyRef,
    sightWordsRef: enSightWordsRef,
    emailHub: enEmailHub,
    learningJourney: enLearningJourney,
    guidanceRef: enGuidanceRef,
    wishlist: enWishlist,
    conversationalEditor: enConversationalEditor,
    learningReport: enLearningReport,
    faq: enFaq,
    review: enReview,
  },
  ja: {
    common: jaCommon,
    nav: jaNav,
    auth: jaAuth,
    pricing: jaPricing,
    home: jaHome,
    course: jaCourse,
    learning: jaLearning,
    legal: jaLegal,
    creator: jaCreator,
    tokens: jaTokens,
    referral: jaReferral,
    placementTest: jaPlacementTest,
    writing: jaWriting,
    progression: jaProgression,
    messaging: jaMessaging,
    notification: jaNotification,
    profile: jaProfile,
    welcome: jaWelcome,
    about: jaAbout,
    blog: jaBlog,
    vocabulary: jaVocabulary,
    playlist: jaPlaylist,
    series: jaSeries,
    subtitle: jaSubtitle,
    dictionary: jaDictionary,
    cefrGuide: jaCefrGuide,
    admin: jaAdmin,
    knowledgeGraph: jaKnowledgeGraph,
    phonicsRef: jaPhonicsRef,
    morphRef: jaMorphRef,
    prosodyRef: jaProsodyRef,
    sightWordsRef: jaSightWordsRef,
    emailHub: jaEmailHub,
    learningJourney: jaLearningJourney,
    guidanceRef: jaGuidanceRef,
    wishlist: jaWishlist,
    conversationalEditor: jaConversationalEditor,
    learningReport: jaLearningReport,
    faq: jaFaq,
    review: jaReview,
  },
  ms: {
    common: msCommon,
    nav: msNav,
    auth: msAuth,
    pricing: msPricing,
    home: msHome,
    course: msCourse,
    learning: msLearning,
    legal: msLegal,
    creator: msCreator,
    tokens: msTokens,
    referral: msReferral,
    placementTest: msPlacementTest,
    writing: msWriting,
    progression: msProgression,
    messaging: msMessaging,
    notification: msNotification,
    profile: msProfile,
    welcome: msWelcome,
    about: msAbout,
    blog: msBlog,
    vocabulary: msVocabulary,
    playlist: msPlaylist,
    series: msSeries,
    subtitle: msSubtitle,
    dictionary: msDictionary,
    cefrGuide: msCefrGuide,
    admin: msAdmin,
    knowledgeGraph: msKnowledgeGraph,
    phonicsRef: msPhonicsRef,
    morphRef: msMorphRef,
    prosodyRef: msProsodyRef,
    sightWordsRef: msSightWordsRef,
    emailHub: msEmailHub,
    learningJourney: msLearningJourney,
    guidanceRef: msGuidanceRef,
    wishlist: msWishlist,
    conversationalEditor: msConversationalEditor,
    learningReport: msLearningReport,
    faq: msFaq,
    review: msReview,
  },
  id: {
    common: idCommon,
    nav: idNav,
    auth: idAuth,
    pricing: idPricing,
    home: idHome,
    course: idCourse,
    learning: idLearning,
    legal: idLegal,
    creator: idCreator,
    tokens: idTokens,
    referral: idReferral,
    placementTest: idPlacementTest,
    writing: idWriting,
    progression: idProgression,
    messaging: idMessaging,
    notification: idNotification,
    profile: idProfile,
    welcome: idWelcome,
    about: idAbout,
    blog: idBlog,
    vocabulary: idVocabulary,
    playlist: idPlaylist,
    series: idSeries,
    subtitle: idSubtitle,
    dictionary: idDictionary,
    cefrGuide: idCefrGuide,
    admin: idAdmin,
    knowledgeGraph: idKnowledgeGraph,
    phonicsRef: idPhonicsRef,
    morphRef: idMorphRef,
    prosodyRef: idProsodyRef,
    sightWordsRef: idSightWordsRef,
    emailHub: idEmailHub,
    learningJourney: idLearningJourney,
    guidanceRef: idGuidanceRef,
    wishlist: idWishlist,
    conversationalEditor: idConversationalEditor,
    learningReport: idLearningReport,
    faq: idFaq,
    review: idReview,
  },
  th: {
    common: thCommon,
    nav: thNav,
    auth: thAuth,
    pricing: thPricing,
    home: thHome,
    course: thCourse,
    learning: thLearning,
    legal: thLegal,
    creator: thCreator,
    tokens: thTokens,
    referral: thReferral,
    placementTest: thPlacementTest,
    writing: thWriting,
    progression: thProgression,
    messaging: thMessaging,
    notification: thNotification,
    profile: thProfile,
    welcome: thWelcome,
    about: thAbout,
    blog: thBlog,
    vocabulary: thVocabulary,
    playlist: thPlaylist,
    series: thSeries,
    subtitle: thSubtitle,
    dictionary: thDictionary,
    cefrGuide: thCefrGuide,
    admin: thAdmin,
    knowledgeGraph: thKnowledgeGraph,
    phonicsRef: thPhonicsRef,
    morphRef: thMorphRef,
    prosodyRef: thProsodyRef,
    sightWordsRef: thSightWordsRef,
    emailHub: thEmailHub,
    learningJourney: thLearningJourney,
    guidanceRef: thGuidanceRef,
    wishlist: thWishlist,
    conversationalEditor: thConversationalEditor,
    learningReport: thLearningReport,
    faq: thFaq,
    review: thReview,
  },
  vi: {
    common: viCommon,
    nav: viNav,
    auth: viAuth,
    pricing: viPricing,
    home: viHome,
    course: viCourse,
    learning: viLearning,
    legal: viLegal,
    creator: viCreator,
    tokens: viTokens,
    referral: viReferral,
    placementTest: viPlacementTest,
    writing: viWriting,
    progression: viProgression,
    messaging: viMessaging,
    notification: viNotification,
    profile: viProfile,
    welcome: viWelcome,
    about: viAbout,
    blog: viBlog,
    vocabulary: viVocabulary,
    playlist: viPlaylist,
    series: viSeries,
    subtitle: viSubtitle,
    dictionary: viDictionary,
    cefrGuide: viCefrGuide,
    admin: viAdmin,
    knowledgeGraph: viKnowledgeGraph,
    phonicsRef: viPhonicsRef,
    morphRef: viMorphRef,
    prosodyRef: viProsodyRef,
    sightWordsRef: viSightWordsRef,
    emailHub: viEmailHub,
    learningJourney: viLearningJourney,
    guidanceRef: viGuidanceRef,
    wishlist: viWishlist,
    conversationalEditor: viConversationalEditor,
    learningReport: viLearningReport,
    faq: viFaq,
    review: viReview,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh-TW',
    supportedLngs: ['zh-TW', 'zh-CN', 'ko', 'en', 'ja', 'ms', 'id', 'th', 'vi'],

    ns: ['common', 'nav', 'auth', 'pricing', 'home', 'course', 'learning', 'legal', 'creator', 'tokens', 'referral', 'placementTest', 'writing', 'progression', 'messaging', 'notification', 'profile', 'welcome', 'about', 'blog', 'vocabulary', 'playlist', 'series', 'subtitle', 'dictionary', 'cefrGuide', 'admin', 'knowledgeGraph', 'phonicsRef', 'morphRef', 'prosodyRef', 'sightWordsRef', 'emailHub', 'learningJourney', 'guidanceRef', 'wishlist', 'conversationalEditor', 'learningReport', 'faq', 'review'],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'loopy-language',
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;

// Helper to change language
export const changeLanguage = (lng: string) => {
  i18n.changeLanguage(lng);
  localStorage.setItem('loopy-language', lng);
};

// Available languages for language selector
export const languages = [
  { code: 'zh-TW', name: '繁體中文', flag: '🇹🇼' },
  { code: 'zh-CN', name: '简体中文', flag: '🇨🇳' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'ms', name: 'Bahasa Melayu', flag: '🇲🇾' },
  { code: 'id', name: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'th', name: 'ภาษาไทย', flag: '🇹🇭' },
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
];
